export enum CookieCategories {
  NECESSARY = 'necessary',
  GOOGLE_MAPS = 'google-maps',
  GOOGLE_ANALYTICS = 'google-analytics',
  MARKETING = 'marketing',
}
